import React from "react"
import { Badge } from "../../ui/badge"
import { Button } from "../../ui/button"
import { SvgCalendar, SvgSettings } from "../../icons"

interface Props {
  calendar: any
  setEditCalendarSettings: any
  fetchUserCalendars?: any
}

const ConnectedCalendar: React.FC<Props> = ({
  calendar,
  setEditCalendarSettings,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
        <div className="flex items-center gap-[10px] font-bold text-base">
          <SvgCalendar />
          <span className="whitespace-nowrap">{calendar.calendar_name}</span>
          {calendar?.is_primary && (
            <div className="hidden sm:block ml-[12px]">
              <Badge>Primary</Badge>
            </div>
          )}
        </div>

        <div className="hidden sm:block">
          <Button
            variant="outline"
            onClick={() =>
              setEditCalendarSettings({ show: true, calendar: calendar })
            }
          >
            <SvgSettings fill="#4750F5" className="w-6 h-6" />
            <span className="hidden md:inline">Settings</span>
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-2 mt-2 sm:hidden">
        <Button
          variant="outline"
          onClick={() =>
            setEditCalendarSettings({ show: true, calendar: calendar })
          }
        >
          <SvgSettings fill="#4750F5" className="w-6 h-6" />
          <span className="hidden md:inline">Settings</span>
        </Button>

        {calendar?.is_primary && <Badge>Primary</Badge>}
      </div>
    </div>
  )
}

export default ConnectedCalendar
